import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import Typography from '@mui/material/Typography';
import { useCallback, useId } from 'react';
import { createJoinOutbound } from '../../api/outbound/lobbyOutbounds';
import { isConfigFlagEnabled } from '../../config';
import { useSocketSend } from '../../context/webSocket/webSocketContext';
import { DEFAULT_BACKGROUND_COLOR, LOBBY_AUTO_MTT_COLOR, LOBBY_AUTO_MTT_DIMMED_COLOR, LOBBY_AUTO_MTT_DIMMED_HOVER_COLOR, LOBBY_AUTO_MTT_HOVER_COLOR, LOBBY_ROOM_GENERIC_COLOR, LOBBY_ROOM_GENERIC_DIMMED_COLOR, LOBBY_ROOM_GENERIC_DIMMED_HOVER_COLOR, LOBBY_ROOM_GENERIC_HOVER_COLOR, YELLOW_COLOR } from '../../styles/colors';
import { LobbyRoomFirstRowDisplay } from './lobbyRoomFirstRowDisplay';
import { LobbyRoomSecondRowDisplay } from './lobbyRoomSecondRowDisplay';
function getBackgroundColor(isDimmed, isSpecialRoom) {
    if (isSpecialRoom) {
        return isDimmed ? LOBBY_AUTO_MTT_DIMMED_COLOR : LOBBY_AUTO_MTT_COLOR;
    }
    return isDimmed ? LOBBY_ROOM_GENERIC_DIMMED_COLOR : LOBBY_ROOM_GENERIC_COLOR;
}
function getHoverBackgroundColor(isDimmed, isSpecialRoom) {
    if (isSpecialRoom) {
        return isDimmed ? LOBBY_AUTO_MTT_DIMMED_HOVER_COLOR : LOBBY_AUTO_MTT_HOVER_COLOR;
    }
    return isDimmed ? LOBBY_ROOM_GENERIC_DIMMED_HOVER_COLOR : LOBBY_ROOM_GENERIC_HOVER_COLOR;
}
export const RoomDisplayContainer = styled.div `
  color: black;
  ${({ isDimmed, isSpecialRoom }) => css `
    background-color: ${getBackgroundColor(isDimmed, isSpecialRoom)};
    border: 3px solid ${getBackgroundColor(isDimmed, isSpecialRoom)};
  `}
  border-radius: 14px;
  cursor: pointer;
  filter: drop-shadow(0 10px 0 rgba(0, 0, 0, 0.25));
  &:hover {
    ${({ isDimmed, isSpecialRoom }) => css(css `
          background-color: ${getHoverBackgroundColor(isDimmed, isSpecialRoom)};
        `, !isDimmed &&
    css `
            border-color: white;
          `)}
  }
`;
export const RoomDisplayFirstRowContainer = styled.div `
  display: flex;
  align-items: center;
  padding: 5px;
  flex-flow: row wrap;
  gap: 0 6px;
`;
export const RoomDisplaySecondRowContainer = styled.div `
  background-color: rgba(0, 0, 0, 0.075);
  padding: 5px;
  border-bottom-left-radius: 11px;
  border-bottom-right-radius: 11px;
`;
export const LOBBY_ROOM_CHIP_CSS = css `
  &.MuiChip-root {
    background-color: rgba(255, 255, 255, 0.3);
  }
  .MuiChip-label {
    color: black;
  }
`;
function getIsDimmed(lobbyRoom) {
    if (lobbyRoom.lobbyRoomAvailabilityDisplayType === 'dimmed') {
        return true;
    }
    return !lobbyRoom.isTourneyTable && (lobbyRoom.numPlayersSitting === undefined || lobbyRoom.numPlayersSitting < 1);
}
export const LobbyRoomDisplay = ({ lobbyRoom, currentRoomId }) => {
    const socketSend = useSocketSend();
    const onClick = useCallback(() => {
        socketSend(createJoinOutbound(lobbyRoom.roomId));
    }, [lobbyRoom, socketSend]);
    const isDimmed = getIsDimmed(lobbyRoom);
    const ariaElementId = useId();
    return (_jsxs(RoomDisplayContainer, { "aria-labelledby": ariaElementId, isDimmed: isDimmed, isSpecialRoom: lobbyRoom.isAutoMtt, onClick: onClick, children: [_jsx(LobbyRoomFirstRowDisplay, { lobbyRoom: lobbyRoom, ariaElementId: ariaElementId }), _jsx(LobbyRoomSecondRowDisplay, { lobbyRoom: lobbyRoom }), isConfigFlagEnabled('reconnectBadgeOnLobbyRoom') && currentRoomId === lobbyRoom.roomId && (_jsx("div", { css: css `
            background-color: ${DEFAULT_BACKGROUND_COLOR};
            color: ${YELLOW_COLOR};
            border-radius: 10px;
            text-align: center;
          `, children: _jsx(Typography, { variant: 'subtitle1', children: "RECONNECT" }) }))] }));
};
